module.exports = function () {
  throw new Error('random-access-file is not supported in the browser')
}
